import { useRequestURL } from '#imports'

import type {
  BasePageContentAPI,
  MappedApiPageContent,
  PageCMSError,
  ParentPageInfos,
} from '@backmarket/http-api/src/api-specs-content/models/base-page-content'
import type { ApiBlock } from '@backmarket/http-api/src/api-specs-content/models/block'
import { blockValidationErrors } from '@backmarket/nuxt-layer-cms/validateBlock'
import type { Maybe } from '@backmarket/utils/types/Maybe'

import { formatBlock } from '../helpers/formatBlock'

export function useFormatContentResponse() {
  const currentUrl = useRequestURL()

  function formatContentResponse<P extends BasePageContentAPI>(
    response: P,
  ): MappedApiPageContent<P> {
    const pageName = response.name
    const pageType = response.type

    const apiParentPageInfos = response.parentPageInfos

    const parentPageInfos: Maybe<ParentPageInfos> = apiParentPageInfos
      ? {
          pageName: apiParentPageInfos.name,
          titleBreadcrumb: apiParentPageInfos.titleBreadcrumb,
        }
      : null

    const blocks: ApiBlock[] = []
    const blockErrors: PageCMSError[] = []
    response.blocks.forEach((block) => {
      const errors = blockValidationErrors(block)
      if (errors.length) {
        blockErrors.push(...errors)

        return
      }

      blocks.push(formatBlock(block, currentUrl))
    })

    return {
      ...response,
      parentPageInfos,
      pageName,
      pageType,
      blocks,
      blockErrors,
    }
  }

  return formatContentResponse
}
